<template>
	<div style="background-color: #eee">
		<v-container>
			<v-sheet v-if="checkActivePart('agentRegisterExtraInfo')" class="rounded-xl" style="background-color: transparent;background-image: linear-gradient(180deg, #101828 0%, #1A2439 100%);">
				<div style="background-color: transparent; background-image:radial-gradient(at center center, #7acdff3b 0%, #FFFFFF00 85%);padding:100px">
					<v-row>
						<v-col cols="12" md="6">
							<div class="white--text ff-emkan-bold fs-h3 text-center mt-5">شما هم به جمع پذیرندگان ما در سراسر کشور بپیوندید</div>
							<div class="blue--text ff-emkan fs-h4 fs-h3 text-center">اوج هیجان فروش اقساطی؛ با وام سیتی دیجی بایل</div>
							<div class="text-center pt-10">
								<v-btn class="rounded-xl" color="secondary" elevation="5" @click="scrollToRegisterForm()">
									ثبت درخواست همکاری
								</v-btn>
								<!-- <v-btn x-large color="orange">ثبت درخواست</v-btn> -->
							</div>
						</v-col>
						<v-col cols="12" md="6" class="d-flex justify-end">
							<div style="position: relative;height: 275px;width:300px;background-color: #794aff2e;border-radius: 10px;border: 1px solid #794AFF2E;background-image: url('/iran-map.png');background-repeat: no-repeat;background-size: cover">
								<a class="bdt-icon pos1" target="_self" href="javascript:void(0);" style="">
									<svg aria-hidden="true" class="e-font-icon-svg e-fas-circle" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
										<path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"></path>
									</svg>
								</a>
								<a class="bdt-icon pos2" target="_self" href="javascript:void(0);" style="">
									<svg aria-hidden="true" class="e-font-icon-svg e-fas-circle" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
										<path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"></path>
									</svg>
								</a>
								<a class="bdt-icon pos3" target="_self" href="javascript:void(0);" style="">
									<svg aria-hidden="true" class="e-font-icon-svg e-fas-circle" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
										<path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"></path>
									</svg>
								</a>
								<a class="bdt-icon pos4" target="_self" href="javascript:void(0);" style="">
									<svg aria-hidden="true" class="e-font-icon-svg e-fas-circle" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
										<path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"></path>
									</svg>
								</a>
								<a class="bdt-icon pos5" target="_self" href="javascript:void(0);" style="">
									<svg aria-hidden="true" class="e-font-icon-svg e-fas-circle" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
										<path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"></path>
									</svg>
								</a>
								<a class="bdt-icon pos6" target="_self" href="javascript:void(0);" style="">
									<svg aria-hidden="true" class="e-font-icon-svg e-fas-circle" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
										<path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"></path>
									</svg>
								</a>
								<a class="bdt-icon pos7" target="_self" href="javascript:void(0);" style="">
									<svg aria-hidden="true" class="e-font-icon-svg e-fas-circle" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
										<path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"></path>
									</svg>
								</a>
								<a class="bdt-icon pos8" target="_self" href="javascript:void(0);" style="">
									<svg aria-hidden="true" class="e-font-icon-svg e-fas-circle" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
										<path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"></path>
									</svg>
								</a>
								<a class="bdt-icon pos9" target="_self" href="javascript:void(0);" style="">
									<svg aria-hidden="true" class="e-font-icon-svg e-fas-circle" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
										<path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"></path>
									</svg>
								</a>
								<a class="bdt-icon pos10" target="_self" href="javascript:void(0);" style="">
									<svg aria-hidden="true" class="e-font-icon-svg e-fas-circle" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
										<path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"></path>
									</svg>
								</a>
							</div>
						</v-col>
					</v-row>
					<v-row>
						<v-col>
							<div style="background-color: #101828;padding: 10px;text-align: center; border-radius: 10px;border: 1px solid #354669;color:#fff;font-size: 20px">
								فروشت چند برابر کن ولی بی‌ دردسر
							</div>
							<div style="padding: 40px 10px 40px 10px; color: #aaa;text-align: justify;border-bottom: 1px solid #FFFFFF24">
								فروشگاه اینترنتی خود را به وام سیتی دیجی بایل اضافه کنید تا همچون هزاران فروشگاه معتبر دیگر، امکان خرید اقساطی آسان برای مشتریان شما فراهم شود.
								<br />
								<br />
								در حال حاضر، وام سیتی دیجی بایل با بیش از 2450 فروشگاه حضوری و آنلاین در سراسر کشور همکاری میکنه که هر روز به تعدادشون اضافه میشه...
							</div>
						</v-col>
					</v-row>
					<v-row class="py-5">
						<v-col cols="12" md="4">
							<div class="sjil">
								<div class="value">&lrm;+2450</div>
								<div class="text">پذیرنده</div>
							</div>
						</v-col>
						<v-col cols="12" md="4">
							<div class="sjil">
								<div class="value">100%</div>
								<div class="text">بیشتر بفروشید</div>
							</div>
						</v-col>
						<v-col cols="12" md="4">
							<div class="sjil">
								<div class="value">7/24</div>
								<div class="text">پشتیبانی در دسترس</div>
							</div>
						</v-col>
					</v-row>
				</div>
			</v-sheet>
			<v-row class="mt-10" v-if="checkActivePart('agentRegisterExtraInfo')">
				<v-col cols="12" md="6">
					<div style="height:100%">
						<v-list dense>
							<div class="line-title mb-3">
								<span class="text">مزایای همکاری با ما</span>
								<span class="line"></span>
							</div>
							<v-list-item>
								<v-list-item-avatar>
									<v-icon class="blue darken-4" dark>
										mdi-check
									</v-icon>
								</v-list-item-avatar>
								<v-list-item-content>
									<v-list-item-title class="ff-emkan-bold fs-h5 mb-2">خرید اقساطی آسان</v-list-item-title>
									<v-list-item-title class="fs-h6">مشتریان شما می‌توانند از طریق وام سیتی دیجی بایل، بدون نیاز ضامن و مراجعه به بانک خرید اقساطی خود را انجام دهند.</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
							<v-list-item>
								<v-list-item-avatar>
									<v-icon class="blue darken-4" dark>
										mdi-check
									</v-icon>
								</v-list-item-avatar>
								<v-list-item-content>
									<v-list-item-title class="ff-emkan-bold fs-h5 mb-2">ریسک صفر</v-list-item-title>
									<v-list-item-title class="fs-h6">مسئولیت دریافت اقساط از مشتری به عهده وام سیتی دیجی بایل است. همچنین بعد از ارسال کالا برای مشتری، وام سیتی دیجی بایل مبلغ خرید را با شما تسویه خواهد کرد.</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
							<v-list-item>
								<v-list-item-avatar>
									<v-icon class="blue darken-4" dark>
										mdi-check
									</v-icon>
								</v-list-item-avatar>
								<v-list-item-content>
									<v-list-item-title class="ff-emkan-bold fs-h5 mb-2">برندینگ</v-list-item-title>
									<v-list-item-title class="fs-h6">حضور شما در وب‌سایت وام سیتی دیجی بایل با میلیون‌ها بازدید ماهانه، تاثیر زیادی بر دیده شدن و رشد برند شما خواهد گذاشت.</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
						</v-list>
					</div>
				</v-col>
				<v-col cols="12" md="6">
					<div>
						<v-list dense>
							<div class="line-title mb-3">
								<span class="text">فرآیند همکاری</span>
								<span class="line"></span>
							</div>
							<div>
								روند همکاری با وام سیتی دیجی بایل، بسیار ساده و به صورت زیر است:
							</div>
							<v-list-item>
								<v-list-item-avatar>
									<v-icon class="blue darken-4" dark>
										mdi-check
									</v-icon>
								</v-list-item-avatar>
								<v-list-item-content>
									<v-list-item-title class="ff-emkan-bold fs-h5 mb-2">ثبت فروشگاه در وام سیتی دیجی بایل</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
							<v-list-item>
								<v-list-item-avatar>
									<v-icon class="blue darken-4" dark>
										mdi-check
									</v-icon>
								</v-list-item-avatar>
								<v-list-item-content>
									<v-list-item-title class="ff-emkan-bold fs-h5 mb-2">ثبت درخواست وام توسط مشتریان فروشگاه</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
							<v-list-item>
								<v-list-item-avatar>
									<v-icon class="blue darken-4" dark>
										mdi-check
									</v-icon>
								</v-list-item-avatar>
								<v-list-item-content>
									<v-list-item-title class="ff-emkan-bold fs-h5 mb-2">تایید نهایی وام و شارژ وام کارت</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
							<v-list-item>
								<v-list-item-avatar>
									<v-icon class="blue darken-4" dark>
										mdi-check
									</v-icon>
								</v-list-item-avatar>
								<v-list-item-content>
									<v-list-item-title class="ff-emkan-bold fs-h5 mb-2">ثبت خرید و پرداخت آنلاین با وام کارت</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
							<v-list-item>
								<v-list-item-avatar>
									<v-icon class="blue darken-4" dark>
										mdi-check
									</v-icon>
								</v-list-item-avatar>
								<v-list-item-content>
									<v-list-item-title class="ff-emkan-bold fs-h5 mb-2">تسویه با فروشگاه</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
						</v-list>
					</div>
				</v-col>
			</v-row>
			<v-sheet class="rounded-xl mt-8" style="background-color: transparent" id="registerForm">
				<div style="background-color: transparent;background-image:radial-gradient(rgb(255 255 255) 0%, rgba(255, 255, 255, 0) 85%); padding:30px">
					<div class="text-center ff-emkan-bold fs-h4" style="color:#1c3059">جهت ثبت درخواست پذیرندگی فرم زیر را تکمیل نمایید:</div>
					<v-row align="center" justify="center">
						<v-col cols="10" md="10" xl="8" v-if="validParameters">
							<v-card ref="card" color="#fff" class="mx-auto my-12">
								<v-slide-x-transition :hide-on-leave="true">
									<div v-show="step === 'register'">
										<v-form ref="formRegister" class="mx-2" lazy-validation @submit.prevent="handleRegister">
											<v-row class="pt-4">
												<v-col cols="6">
													نوع شخص:
													<v-btn-toggle v-model="user.metaData.agentType" borderless color="deep-purple accent-3">
														<v-btn :value="0">
															<span class="">حقیقی</span>
														</v-btn>

														<v-btn :value="1">
															<span class="">حقوقی</span>
														</v-btn>
													</v-btn-toggle>
												</v-col>
												<v-col cols="6" class="d-flex align-center">
													<span class="pt-2">نحوه فعالیت:</span>
													<v-checkbox color="secondary" v-model="user.metaData.isPhysical" label="حضوری" :value="true" hide-details compact class="mr-2"></v-checkbox>
													<v-checkbox color="secondary" v-model="user.metaData.isOnline" label="آنلاین" :value="true" hide-details compact class="mr-2"></v-checkbox>
												</v-col>
											</v-row>
											<v-row class="">
												<v-col cols="12" md="4" class="py-0 mx-0" v-if="user.metaData.agentType === 1">
													<v-text-field class="mx-0" v-model="user.metaData.companyName" label="نام شرکت" :error-messages="errorMessages" :rules="[(val) => !!val || 'نام شرکت را وارد کنید']" focused required />
												</v-col>
												<v-col cols="12" md="4" class="py-0 mx-0" v-if="user.metaData.agentType === 1">
													<v-text-field class="mx-0" v-model="user.metaData.shenaseMelli" label="شناسه ملی" :error-messages="errorMessages" :rules="[(val) => !!val || 'شناسه ملی شرکت را وارد کنید']" required />
												</v-col>
												<v-col cols="12" md="4" class="py-0 mx-0" v-if="user.metaData.agentType === 1">
													<v-text-field class="mx-0" v-model="user.metaData.shomareSabt" label="شماره ثبت" :error-messages="errorMessages" :rules="[(val) => !!val || 'شماره ثبت شرکت را وارد کنید']" required />
												</v-col>
												<v-col cols="12" md="4" class="py-0 mx-0">
													<v-text-field class="mx-0" v-model="user.firstName" :label="user.metaData.agentType === 0 ? 'نام و نام خانوادگی' : 'نام مدیر عامل'" :error-messages="errorMessages" :rules="[(val) => !!val || 'نام را وارد کنید']" focused required />
												</v-col>
												<v-col cols="12" md="4" class="py-0 mx-0" v-if="user.metaData.agentType === 0">
													<v-text-field class="mx-0" v-model="user.fatherName" label="نام پدر" :error-messages="errorMessages" :rules="[(val) => !!val || 'نام پدر را وارد کنید']" required />
												</v-col>
												<v-col cols="12" md="4" class="py-0 mx-0">
													<v-text-field class="left-input mx-0" v-model="user.nationalCode" :label="user.metaData.agentType === 0 ? 'کد ملی' : 'کد ملی مدیر عامل'" maxlength="10" :error-messages="errorMessages" :rules="[(val) => !!val || 'کد ملی را وارد کنید', (val) => checkCodeMeli(val) || 'کد ملی وارد شده معتبر نمی باشد']" />
												</v-col>
												<v-col cols="12" md="4" class="py-0 mx-0">
													<v-text-field class="left-input mx-0" v-model="user.shenasname" :label="user.metaData.agentType === 0 ? 'شماره شناسنامه' : 'شماره شناسنامه مدیر عامل'" maxlength="10" :error-messages="errorMessages" :rules="[(val) => !!val || 'شماره شناسنامه را وارد کنید']" />
												</v-col>
												<v-col cols="12" md="4" class="py-0 mx-0">
													<v-text-field class="mx-0" v-model="user.businessName" label="نام تجاری" :error-messages="errorMessages" :rules="[(val) => !!val || 'نام تجاری را وارد کنید']" required />
												</v-col>
												<v-col cols="12" md="4" class="py-0 mx-0">
													<v-text-field class="left-input mx-0" v-model="user.phone" label="تلفن ثابت" maxlength="20" />
												</v-col>
												<v-col cols="12" md="4" class="py-0 mx-0">
													<v-text-field class="left-input mx-0" v-model="user.mobile" label="شماره موبایل" maxlength="11" hint="کد تائیدیه به این شماره ارسال می شود" :error-messages="errorMessages" :rules="[(value) => !!value || 'موبایل را وارد کنید', (value) => isPhoneNumberValid() || 'موبایل را به صورت صحیح وارد کنید']" required />
													<!-- <v-text-field maxlength="11" dark v-model="user.mobile" label="شماره موبایل" hint="شماره موبایل به صورت صحیح وارد شود. کد به این شماره ارسال می شود" :error-messages="errorMessages" :rules="[(value) => !!value || 'موبایل را وارد کنید', (value) => isPhoneNumberValid() || 'موبایل را به صورت صحیح وارد کنید']" required /> -->
												</v-col>
												<v-col cols="12" md="4" class="py-0 mx-0">
													<v-text-field class="left-input mx-0" v-model="user.email" label="ایمیل" :error-messages="errorMessages" :rules="[(value) => !!value || 'ایمیل را وارد کنید', (value) => isEmailValid() || 'ایمیل را به صورت صحیح وارد کنید']" required />
												</v-col>

												<v-col cols="12" md="4" class="py-0 mx-0" v-if="user.metaData.agentType === 1">
													<v-text-field class="mx-0" v-model="user.metaData.signaturesOwnerNames" label="نام صاحبین امضا" :error-messages="errorMessages" :rules="[(val) => !!val || 'نام صاحبین امضا را وارد کنید']" required />
												</v-col>
												<v-col cols="12" md="12" class="pys-2 mx-0">
													<div class="">نوع محصولات کسب و کار:</div>
													<div class="d-flex flex-wrap">
														<v-checkbox v-model="services.one" label="موبایل و کالای دیجیتال" value="موبایل و کالای دیجیتال" hide-details compact class="ml-2"></v-checkbox>
														<v-checkbox v-model="services.two" label="لوازم خانگی و دکوراسیون" value="لوازم خانگی و دکوراسیون" hide-details compact class="ml-2"></v-checkbox>
														<v-checkbox v-model="services.three" label="خودرو و موتور سیکلت" value="خودرو و موتور سیکلت" hide-details compact class="ml-2"></v-checkbox>
														<v-checkbox v-model="services.four" label="طلا و جواهرات" value="طلا و جواهرات" hide-details compact class="ml-2"></v-checkbox>
														<v-checkbox v-model="services.five" label="ارائه خدمات" value="ارائه خدمات" hide-details compact class="ml-2"></v-checkbox>
													</div>
												</v-col>
											</v-row>
											<v-row class="mt-3">
												<v-col cols="12" md="2" class="py-0 mx-0">
													<v-text-field ref="city" v-model="user.city" label="شهر" :rules="[() => !!user.city || 'شهر را وارد کنید']" />
												</v-col>
												<v-col cols="12" md="2" class="py-0 mx-0">
													<v-text-field ref="postalCode" v-model="user.postalCode" label="کد پستی" maxlength="10" :rules="[(val) => !!val || 'کد پستی را وارد کنید']" required />
												</v-col>
												<v-col cols="12" md="8" class="py-0 mx-0">
													<v-text-field ref="address" v-model="user.address" label="آدرس" :rules="[() => !!user.address || 'آدرس را وارد کنید']" />
												</v-col>
												<v-col cols="12" md="6" class="py-0 mx-0">
													<v-text-field ref="shaba" class="left-input" placeholder="IR" v-model="shaba" label="شماره شبا بنام صاحب کسب و کار" :rules="[(val) => !!val || 'شماره شبا را وارد کنید']" />
												</v-col>
												<v-col cols="12" md="6" class="py-0 mx-0">
													<v-text-field class="left-input" :disabled="readonly" placeholder="http://" v-model="user.metaData.siteUrl" label="آدرس وب سایت: (با http شروع شود)" :rules="[(val) => !user.metaData.isOnline || (user.metaData.isOnline && !!val) || 'آدرس وب سایت را وارد کنید']" />
												</v-col>
											</v-row>
											<v-row>
												<v-col cols="12" class="">
													لطفا مدارک زیر را بارگذاری نمایید:
												</v-col>
												<v-col cols="12" md="3">
													<div style="border-bottom:1px dashed #ddd; text-align: center; margin-bottom: 10px;display: flex;justify-content: center">
														<v-icon style="transform:rotate(-45deg)">mdi-attachment</v-icon>
														<span>لوگو</span>
													</div>
													<ImageUploader :downloadable="false" ref="thumbnailFileUploader" v-model="user.metaData.thumbnailBase64" :errorImage="require('@/assets/no-image.png')" @imageClicked="viewImage(user.metaData.thumbnailBase64)" @delete="() => user.metaData.thumbnailFileName = ''" />
												</v-col>
												<v-col cols="12" md="3">
													<div style="border-bottom:1px dashed #ddd; text-align: center; margin-bottom: 10px;display: flex;justify-content: center">
														<v-icon style="transform:rotate(-45deg)">mdi-attachment</v-icon>
														<span>{{ user.metaData.agentType === 0 ? 'کارت ملی' : 'کارت ملی مدیر عامل' }}</span>
													</div>
													<ImageUploader :downloadable="false" ref="kartmelliFileUploader" v-model="user.metaData.kartMelliBase64" :errorImage="require('@/assets/no-image.png')" @imageClicked="viewImage(user.metaData.kartMelliBase64)" @delete="() => user.metaData.kartMelliFileName = ''" />
												</v-col>
												<v-col cols="12" md="3" v-if="user.metaData.agentType === 0">
													<div style="border-bottom:1px dashed #ddd; text-align: center; margin-bottom: 10px;display: flex;justify-content: center">
														<v-icon style="transform:rotate(-45deg)">mdi-attachment</v-icon>
														<span>اجاره نامه یا سند</span>
													</div>
													<ImageUploader :downloadable="false" ref="ejarenameFileUploader" v-model="user.metaData.ejarenameBase64" :errorImage="require('@/assets/no-image.png')" @imageClicked="viewImage(user.metaData.ejarenameBase64)" @delete="() => user.metaData.ejarenameFileName = ''" />
												</v-col>
												<v-col cols="12" md="3" v-if="user.metaData.agentType === 0">
													<div style="border-bottom:1px dashed #ddd; text-align: center; margin-bottom: 10px;display: flex;justify-content: center">
														<v-icon style="transform:rotate(-45deg)">mdi-attachment</v-icon>
														<span>جواز کسب</span>
													</div>
													<ImageUploader :downloadable="false" ref="javazKasbFileUploader" v-model="user.metaData.javazKasbBase64" :errorImage="require('@/assets/no-image.png')" @imageClicked="viewImage(user.metaData.javazKasbBase64)" @delete="() => user.metaData.javazKasbFileName = ''" />
												</v-col>
												<v-col cols="12" md="3" v-if="user.metaData.agentType === 1">
													<div style="border-bottom:1px dashed #ddd; text-align: center; margin-bottom: 10px;display: flex;justify-content: center">
														<v-icon style="transform:rotate(-45deg)">mdi-attachment</v-icon>
														<span>تصویر اساسنامه</span>
													</div>
													<ImageUploader :downloadable="false" ref="asasnameFileUploader" v-model="user.metaData.asasnameBase64" :errorImage="require('@/assets/no-image.png')" @imageClicked="viewImage(user.metaData.asasnameBase64)" @delete="() => user.metaData.asasnameFileName = ''" />
												</v-col>
												<v-col cols="12" md="3" v-if="user.metaData.agentType === 1">
													<div style="border-bottom:1px dashed #ddd; text-align: center; margin-bottom: 10px;display: flex;justify-content: center">
														<v-icon style="transform:rotate(-45deg)">mdi-attachment</v-icon>
														<span>تصویر روزنامه رسمی</span>
													</div>
													<ImageUploader :downloadable="false" ref="roznameRasmiFileUploader" v-model="user.metaData.roznameRasmiBase64" :errorImage="require('@/assets/no-image.png')" @imageClicked="viewImage(user.metaData.roznameRasmiBase64)" @delete="() => user.metaData.roznameRasmiFileName = ''" />
												</v-col>
												<v-col cols="12" md="3">
													<div style="border-bottom:1px dashed #ddd; text-align: center; margin-bottom: 10px;display: flex;justify-content: center">
														<v-icon style="transform:rotate(-45deg)">mdi-attachment</v-icon>
														<span>تصویر چک ضمانت</span>
													</div>
													<ImageUploader :downloadable="false" ref="pledgeChequeFileUploader" v-model="user.metaData.pledgeChequeBase64" :errorImage="require('@/assets/no-image.png')" @imageClicked="viewImage(user.metaData.pledgeChequeBase64)" @delete="() => user.metaData.pledgeChequeFileName = ''" />
												</v-col>

											</v-row>
											<v-card color="#e3e3e3" class="pa-8 my-3">
												<v-row style="border: 1px solid rgb(53, 70, 105);" class="secondary">
													<v-col cols="12" class="py-0 mx-0 text-center white--text fs-h3">
														نام کاربری: {{ username }}
													</v-col>
													<v-col cols="12" style="border-top: 1px dashed rgb(53, 70, 105)">
														<div class="text-center">
															<small class="white--text">{{ `دقت شود نام کاربری با شماره موبایل و پیشوند n می باشد. ${this.customerCode && this.customerCode != 0 ? 'دقت شود نام کاربری دارای کد پیشوند ' + this.customerCode + ' می باشد.' : ''}` }}</small>
														</div>
													</v-col>
												</v-row>
												<v-row class="mt-8">
													<v-col cols="12" md="6" class="py-0 mx-0">
														<v-text-field class="left-input mx-0" v-model="user.password" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :rules="[() => !!user.password || 'کلمه عبور را وارد کنید', (val) => checkPasswordPolicy() || 'کلمه عبور نباید کمتر از 8 کاراکتر باشد']" :error-messages="errorMessages" :type="show1 ? 'text' : 'password'" name="password" label="کلمه عبور" @click:append="show1 = !show1" />
													</v-col>
													<v-col cols="12" md="6" class="py-0 mx-0">
														<v-text-field class="left-input mx-0" v-model="user.confirmPassword" :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'" :rules="[() => user.confirmPassword === user.password || 'تکرار کلمه عبور با کلمه عبور مطابقت ندارد']" :error-messages="errorMessages" :type="show2 ? 'text' : 'password'" name="confirmPassword" label="تکرار کلمه عبور" @click:append="show2 = !show2" />
													</v-col>
												</v-row>
												<v-row class="mx-0">
													<v-col cols="4" class="px-0">
														<v-text-field label="کد امنیتی" maxLength="4" v-model="registerCaptcha">
														</v-text-field>
													</v-col>
													<v-col cols="8" sm="5" md="5" class="" style="direction: ltr;display: flex;align-items: center;justify-content: end;">
														<v-btn class="mr-1" color="secondary" small fab icon @click="refreshRegisterCaptcha()"><v-icon>mdi-refresh</v-icon></v-btn>
														<CaptchaImage ref="registerCaptcha" :codeType="['0']" style="direction: ltr;" />
													</v-col>
												</v-row>
											</v-card>
											<div class="form-group">
												<v-alert v-if="message" type="error" outlined>
													{{ message }}
												</v-alert>
											</div>
											<v-card-actions>
												<v-spacer />
												<v-btn ref="submit" class="rounded-xl" color="secondary" elevation="5" dark :loading="loading" type="submit">
													ثبت نام
												</v-btn>
												<v-spacer />
											</v-card-actions>
										</v-form>
									</div>
								</v-slide-x-transition>
							</v-card>
							<v-card ref="card" class="mx-auto my-12">
								<v-slide-x-transition :hide-on-leave="true">
									<div v-show="step === 'smsCode'">
										<div class="pa-5 text-center grey--text">لطفا جهت تکمیل ثبت نام، کد تائیدیه ارسال شده به شماره <span class="secondary--text mx-1">{{ user.mobile }}</span> را ثبت کنید</div>
										<v-form ref="formSmsCode" class="mx-2" lazy-validation>
											<v-row>
												<v-col cols="12" class="mt-4">
													<div class="d-flex justify-center flex-row-reverse">
														<v-text-field class="code-inputs" outlined v-model="smsCode.activationCode[0]" maxLength="1" type="tel" tabindex="1" @input="focusOnNext()" autofocus />
														<v-text-field class="code-inputs" outlined v-model="smsCode.activationCode[1]" maxLength="1" type="tel" tabindex="2" @input="focusOnNext()" />
														<v-text-field class="code-inputs" outlined v-model="smsCode.activationCode[2]" maxLength="1" type="tel" tabindex="3" @input="focusOnNext()" />
														<v-text-field class="code-inputs" outlined v-model="smsCode.activationCode[3]" maxLength="1" type="tel" tabindex="4" @input="focusOnNext()" />
														<v-text-field class="code-inputs" outlined v-model="smsCode.activationCode[4]" maxLength="1" type="tel" tabindex="5" @input="focusOnNext()" @keyup.enter="handleSmsCode" />
													</div>
												</v-col>
											</v-row>
											<v-card-actions>
												<v-spacer />
												<v-btn color="secondary" dark :loading="loading" @click="handleSmsCode">
													ثبت کد
												</v-btn>
												<v-spacer />
											</v-card-actions>
											<div class="form-group">
												<v-alert type="error" v-if="smsCodeMessage" outlined>
													{{ smsCodeMessage }}
												</v-alert>
											</div>
											<div class="text-center my-3">
												<v-btn class="mx-auto mb-2" text @click="step = 'register'">بازگشت به ثبت نام</v-btn>
											</div>
										</v-form>
									</div>
								</v-slide-x-transition>
							</v-card>
							<v-card ref="card" class="mx-auto my-12">
								<v-slide-x-transition :hide-on-leave="true">
									<div v-show="step === 'verifySuccess'">
										<div class="d-flex flex-column justify-center align-center" style="height:200px;background-color: rgb(182 255 193);">
											<v-icon size="100" color="success">
												mdi-check-circle
											</v-icon>
										</div>
										<p class="success--text py-3 text-center">تائید کد با موفقیت انجام شد.</p>
										<div class="text-center mb-3">تا لحظاتی دیگر به پنل کاربری هدایت می شوید...</div>
										<div class="form-group px-3">
											<v-alert type="error" v-if="redirectToPanelMessage" outlined>
												{{ redirectToPanelMessage }}
											</v-alert>
										</div>
										<div class="text-center my-3">
											<v-btn class="mx-auto mb-2" color="secondary" @click="goLoginPage" :loading="redirectToPanelLoading">ورود به پنل کاربری</v-btn>
										</div>
									</div>
								</v-slide-x-transition>
							</v-card>
						</v-col>
						<v-col cols="10" md="6" xl="4" v-else>
							<v-card ref="card" class="mx-auto my-12">
								<v-slide-x-transition :hide-on-leave="true">
									<div>
										<v-img class="white--text align-end" height="200px" src="/login-banner.jpg">
											<v-card-title>جهت ثبت درخواست وام ابتدا باید ثبت نام خود را تکمیل نمایید</v-card-title>
										</v-img>
										<v-alert type="error" outlined>
											اطلاعات پارامترهای مشتری معتبر نمی باشد
										</v-alert>
									</div>
								</v-slide-x-transition>
							</v-card>

						</v-col>
					</v-row>
				</div>
			</v-sheet>
			<v-sheet class="rounded-lg my-15" style="background-color: #36274c;" v-if="checkActivePart('agentRegisterExtraInfo')">
				<v-row>
					<v-col cols="12" sm="9" class="d-flex align-center" style="background-color: #101828; border-radius: 50px 20px 20px 50px;padding:14px 30px;background-image: url('/halftone_background_12-2.png')">
						<div class="fs-h3 text-center white--text">
							با ما در تماس باشید و مشاوره رایگان دریافت کنید
						</div>
					</v-col>
					<v-col cols="12" sm="3" style="padding: 20px">
						<div class="d-flex">
							<div style="flex-grow:2">
								<div class="fs-h4 text-left white--text">021-91690823</div>
								<div class=" text-left white--text">امور نمایندگان</div>
							</div>
							<div class="d-flex align-center pr-2">
								<v-icon color="white" style="padding: 5px;background-color: #101828;border-radius: 8px;">mdi-phone-in-talk-outline</v-icon>
							</div>
						</div>
					</v-col>
				</v-row>

			</v-sheet>
		</v-container>
	</div>
</template>

<script>
	import api from '@/util/app-api'
	import CaptchaImage from '@/components/app/CaptchaImage.vue'
	import { get } from 'vuex-pathify'
	import { setCookie, getCookie } from '@/util/helpers'
	import router from '../../router'
	import ThemeManager from '@/util/theme-manager.js'
	import { user } from '../../store/modules'
	import ImageUploader from '@/components/uploader/ImageUploader'
	import { obj2FormData } from '@/util/helpers.js'

	export default {
		name: 'Register',
		components: {
			CaptchaImage: CaptchaImage,
			ImageUploader
		},
		data() {
			return {
				registerCaptcha: '',
				smsCodeCaptcha: '',
				step: 'register',
				smsCode: { activationCode: [null, null, null, null, null, null], userId: 0, code: '' },
				user: { metaData: { agentType: 0 }, firstName: '', lastName: '', nationalCode: '', businessName: '', city: '', postalCode: '', address: '', phone: '', mobile: '', password: '', confirmPassword: '' },
				//user: { metaData: { agentType: 0 }, firstName: 'اصغر اصغری', fatherName: 'اکبر', lastName: '', nationalCode: '2300320411', businessName: 'فروشگاه تست', city: 'شیراز', postalCode: '1234567890', address: 'شیراز سردوزک', phone: '071216546216', mobile: '09361111111', password: '123456789', confirmPassword: '123456789' },
				loading: false,
				redirectToPanelLoading: false,
				message: '',
				smsCodeMessage: '',
				errorMessages: '',
				redirectToPanelMessage: '',
				show1: false,
				show2: false,
				customerCode: '',
				validParameters: true,
				usernameLocal: '',
				services: { one: '', two: '', three: '', four: '', five: '' },
				shaba: '',
				readonly: false
			}

		},
		computed: {
			...get('siteConfig', [
				'isCloud', 'longTitle'
			]),
			loggedIn() {
				return this.$store.state.auth.status.loggedIn
			},
			username: {
				get() {
					if (!this.user.mobile)
						return '---'
					return `${this.isCloud && this.customerCode && this.user.mobile ? this.customerCode + '-n-' : 'n'}${this.user.mobile}`
				},
				set(val) {
					this.usernameLocal = val
				},
			}
		},
		created() {
			ThemeManager.ApplyThemeSettings(this.$route.params.customerCode || 0, this.$vuetify)
		},
		mounted() {
			this.customerCode = this.$route.params.customerCode || 0
			if ((!this.customerCode || isNaN(this.customerCode)) && this.isCloud)
				this.validParameters = false

			// this.manageAffiliate()
			// this.manageAgentCode()
		},
		methods: {
			manageAffiliate() {
				let mrk = this.$route.query.mrk
				if (!mrk)
					return

				setCookie('mrk', mrk, 180)

				let customerCode = this.$route.params.customerCode || 0
				api.post(`Visitor/LogVisitor/?customerCode=${customerCode}&mrkCode=${mrk}`, {}, { authHeader: false, contentType: 'application/json' })
					.then(response => {
					})
					.catch(err => {
					})
			},
			manageAgentCode() {
				let agn = this.$route.query.agn
				if (!agn)
					return

				setCookie('agn', agn, 180)
			},
			handleRegister() {
				if (!this.$refs.formRegister.validate()) {
					this.message = 'لطفا موارد الزامی فرم را تکمیل نمایید.'
					return
				}
				if (!(Object.values(this.services) || []).filter(x => x)?.length) {
					this.message = 'نوع محصولات کسب و کار را انتخاب نمایید.'
					return
				}
				if (!this.$refs.registerCaptcha.verify(this.registerCaptcha)) {
					this.message = 'کد امنیتی صحیح نمی باشد.'
					return
				} else {
					this.message = ''
				}
				this.user.customerCode = this.customerCode
				this.loading = true
				if (this.shaba) {
					this.user.bankAccountsJson = JSON.stringify([{ accountNumber: this.shaba, bank: '', branch: '' }])
				} else {
					this.user.bankAccountsJson = '[]'
				}
				this.user.metaData.agentCategoryActivities = (Object.values(this.services) || []).filter(x => x).join(',')
				let data = {}
				Object.assign(data, this.user)
				delete data.metaData.thumbnailBase64
				delete data.metaData.kartMelliBase64
				delete data.metaData.ejarenameBase64
				delete data.metaData.javazKasbBase64
				delete data.metaData.asasnameBase64
				delete data.metaData.roznameRasmiBase64
				delete data.metaData.pledgeChequeBase64
				const formData = obj2FormData(data)
				var fileUploader_thumbnail = this.$refs['thumbnailFileUploader'] ? this.$refs['thumbnailFileUploader'] : null
				if (fileUploader_thumbnail && fileUploader_thumbnail.hasFile()) {
					formData.append('metaData.thumbnailFile', fileUploader_thumbnail.getFile())
				}
				var fileUploader_kartmelli = this.$refs['kartmelliFileUploader'] ? this.$refs['kartmelliFileUploader'] : null
				if (fileUploader_kartmelli && fileUploader_kartmelli.hasFile()) {
					formData.append('metaData.kartMelliFile', fileUploader_kartmelli.getFile())
				}
				var fileUploader_ejarename = this.$refs['ejarenameFileUploader'] ? this.$refs['ejarenameFileUploader'] : null
				if (fileUploader_ejarename && fileUploader_ejarename.hasFile()) {
					formData.append('metaData.ejarenameFile', fileUploader_ejarename.getFile())
				}
				var fileUploader_javazKasb = this.$refs['javazKasbFileUploader'] ? this.$refs['javazKasbFileUploader'] : null
				if (fileUploader_javazKasb && fileUploader_javazKasb.hasFile()) {
					formData.append('metaData.javazKasbFile', fileUploader_javazKasb.getFile())
				}
				var fileUploader_asasname = this.$refs['asasnameFileUploader'] ? this.$refs['asasnameFileUploader'] : null
				if (fileUploader_asasname && fileUploader_asasname.hasFile()) {
					formData.append('metaData.asasnameFile', fileUploader_asasname.getFile())
				}
				var fileUploader_roznameRasmi = this.$refs['roznameRasmiFileUploader'] ? this.$refs['roznameRasmiFileUploader'] : null
				if (fileUploader_roznameRasmi && fileUploader_roznameRasmi.hasFile()) {
					formData.append('metaData.roznameRasmiFile', fileUploader_roznameRasmi.getFile())
				}
				var fileUploader_pledgeCheque = this.$refs['pledgeChequeFileUploader'] ? this.$refs['pledgeChequeFileUploader'] : null
				if (fileUploader_pledgeCheque && fileUploader_pledgeCheque.hasFile()) {
					formData.append('metaData.pledgeChequeFile', fileUploader_pledgeCheque.getFile())
				}
				api.post('account/preAgentRegisterAndSendOTP/', formData, { authHeader: false, contentType: 'multipart/form-data' })
					.then(response => {
						this.smsCode.userId = response.userId
						this.smsCodeMessage = ''
						if (response.isOtpActive) {
							this.step = 'smsCode'
						}
						else {
							this.step = 'verifySuccess'
							this.redirectToPanel()
						}

					})
					.catch(err => {
						this.message = err.message
					})
					.finally(() => {
						this.loading = false
					})
			},
			handleSmsCode() {
				if (!this.$refs.formSmsCode.validate()) { return }

				this.loading = true
				this.smsCode.code = this.smsCode.activationCode.join('')
				api.post('account/verifySmsCode/', this.smsCode, { authHeader: false, contentType: 'application/json' })
					.then(response => {
						this.step = 'verifySuccess'
						this.redirectToPanel()
					})
					.catch(err => {
						this.smsCodeMessage = err.message
						this.loading = false
					})
			},
			redirectToPanel() {
				this.redirectToPanelLoading = true
				setTimeout(() => {
					this.user.username = this.username
					this.$store.dispatch('auth/login', this.user).then((to) => {
						// router.replace('/member/LoanRequest/' + response).catch(() => { })
						this.$router.replace('/agent/dashboard/').catch(() => { })
						this.redirectToPanelLoading = false
					}).catch(error => {
						this.redirectToPanelLoading = false
						this.redirectToPanelMessage = error.message || error.toString()
					})
				}, 2000)
			},
			refreshRegisterCaptcha() {
				this.$refs.registerCaptcha.refresh()
			},
			refreshSmsCodeCaptcha() {
				this.$refs.smsCodeCaptcha.refresh()
			},
			goLoginPage() {
				this.$router.replace('/login').catch(() => { })
			},
			checkCodeMeli(code) {
				if (!code)
					return true

				var L = code.length

				if (L < 8 || parseInt(code, 10) == 0) return false
				code = ('0000' + code).substr(L + 4 - 10)
				if (parseInt(code.substr(3, 6), 10) == 0) return false
				var c = parseInt(code.substr(9, 1), 10)
				var s = 0
				for (var i = 0; i < 9; i++)
					s += parseInt(code.substr(i, 1), 10) * (10 - i)
				s = s % 11
				return (s < 2 && c == s) || (s >= 2 && c == (11 - s))
			},
			isPhoneNumberValid() {
				return this.user.mobile && (/^((?!(0))[0-9]{10})$/g.test(this.user.mobile) || /^0[0-9]\d{9}$/g.test(this.user.mobile))
			},
			checkPasswordPolicy() {
				if (!(this.user.password.length > 8))
					return false
				return true
			},
			focusOnNext() {
				var currInput = document.activeElement
				if (currInput?.tagName.toLowerCase() == "input") {
					var inputs = document.getElementsByTagName("input")
					var currInput = document.activeElement
					for (var i = 0; i < inputs.length; i++) {
						if (inputs[i] == currInput) {
							var next = inputs[i + 1]
							if (next && next.focus) {
								next.focus()
							}
							break
						}
					}
				}
			},
			scrollToRegisterForm() {
				document.getElementById("registerForm").scrollIntoView()
			},
			isEmailValid() {
				return this.user.email &&
					/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/g.test(this.user.email)
			}
		},
	}
</script>

<style scoped
	lang="scss">
		.fs-h1 {
			font-size: 3.3125rem !important;
		}

		.fs-h2 {
			font-size: 2.25rem !important;
		}

		.fs-h3 {
			font-size: 1.5625rem !important;
		}

		.fs-h4 {
			font-size: 1.125rem !important;
		}

		.fs-h5 {
			font-size: 1.0625rem !important;
		}

		.fs-h6 {
			font-size: 0.75rem !important;
		}

		.fs-subtitle-1 {
			font-size: 0.875rem !important;
		}

		.fs-subtitle-2 {
			font-size: 0.875rem !important;
		}

		.fs-caption {
			font-size: 0.8125rem !important;
		}

		.bdt-icon {
			margin: 0;
			border: none;
			border-radius: 0;
			overflow: visible;
			font: inherit;
			color: inherit;
			text-transform: none;
			padding: 0;
			background-color: transparent;
			display: inline-block;
			fill: currentcolor;
			line-height: 0;
			color: #794AFF;
			background-color: #FFFFFF;
			padding: 5px;
			font-size: 10px;
			opacity: 1;
			position: absolute;
			border-radius: 100px;
		}

		.bdt-icon:before,
		.bdt-icon:after {
			position: absolute;
			top: 50%;
			right: 50%;
			display: block;
			content: '';
			border: 1px solid rgba(255, 255, 255, 0.5);
			border-radius: 200px;
			transform: scale(.35) translateY(-50%) translateX(50%);
			opacity: 0;
			animation: marker-ripple-animation 2.6s cubic-bezier(.25, .9, .2, 1) .4s infinite;
			width: 100%;
			height: 100%;
		}

		.bdt-icon:after {
			border-color: rgba(255, 255, 255, 0.4);
			animation: marker-ripple-animation 2.6s cubic-bezier(.25, .9, .2, 1) 0s infinite;
		}

		@keyframes marker-ripple-animation {
			0% {
				transform: translate3d(50%, -50%, 0) scale(1);
				opacity: 1;
			}

			100% {
				transform: translate3d(50%, -50%, 0) scale(1.7);
				opacity: 0;
			}

		}

		.bdt-icon svg {
			fill: var(--e-global-color-uicore_primary);
			height: 1em;
			transition: transform .3s;
			width: 1em;
		}

		.bdt-icon.pos1 {
			top: 10%;
			left: 10%;
		}

		.bdt-icon.pos2 {
			top: 29%;
			left: 33%;
		}

		.bdt-icon.pos3 {
			top: 16%;
			left: 13%;
		}

		.bdt-icon.pos4 {
			top: 30%;
			left: 10%;
		}

		.bdt-icon.pos5 {
			top: 55%;
			left: 55%;
		}

		.bdt-icon.pos6 {
			top: 50%;
			left: 23%;
		}

		.bdt-icon.pos7 {
			top: 80%;
			left: 40%;
		}

		.bdt-icon.pos8 {
			top: 30%;
			left: 63%;
		}

		.bdt-icon.pos9 {
			top: 32%;
			left: 65%;
		}

		.bdt-icon.pos10 {
			top: 84%;
			left: 76%;
		}

		.sjil .value {
			color: #794AFF;
			font-size: 50px;
			text-align: center;
		}

		.sjil .text {
			color: #aaa;
			font-size: 14px;
			text-align: center;
		}

		.line-title {
			position: relative;
			display: flex;

			.line {
				position: relative;
				flex-grow: 2;

				&:after {
					position: absolute;
					content: " ";
					background-color: #cdcdcd47;
					height: 2px;
					right: 0;
					left: 0;
					top: 25px;
				}
			}

			.text {
				padding-left: 20px;
				font-size: 1.5rem !important;
				color: #1c3059;
				font-family: "Emkan-Bold", "Yekan", "tahoma";
			}

			&:after {
				height: 2px;
				width: 50px;
				content: "";
				position: absolute;
				left: 0;
				height: 2px;
				top: 46%;
				background-color: #1c3059;
			}
		}

		.code-inputs {
			width: 55px;
			max-width: 55px;
			margin: 0 10px;
			text-align: center;
		}
	</style>
